import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
//引入invite 组件
import Invite from '@/components/Invite'
//引入share组件
import Share from '@/components/Share'
// 引入 语聊邀请分享
import VoiceInvite from "@/Component/VoiceInvite"
// 引入游戏房间组件
import Invitegameroom from "@/components/Invitegameroom"
//引入剧本分享组件
import Scriptinfos from "@/components/Scriptinfos"
//引入谜谭组件
import fiction from "@/components/fiction"
//引入广场分享组件
import Squareshare from "@/components/Squareshare"
//谁是卧底 规则
import Deceitserves  from "@/components/deceit/game_serves"
import Deceitshare  from "@/components/deceit/deceit_share"
//狼人杀
import Lrsrules from "@/components/lrs/lrs_rules"
import LrsShare from "@/components/lrs/lrs_share"
//你画我猜
import Drawrules from "@/components/draw/draw_rules"
import DrawShare from "@/components/draw/draw_share"

//抽奖
import Lottery from '@/components/wsm_lottery/view/lottery_home'

//微信支付教程
import Weixincourse from '@/components/wsm_month_card/pay/one'
//月卡领取教程
import Yuekacourse from  '@/components/wsm_month_card/get/one'

//月卡说明
import Yuekainfos from '@/components/monthtext'

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Invite',
      component: Invite,
      meta:{
        title:"邀请好友"
      }
    },
    {
      path: '/share/:id',
      name: 'Share',
      component: Share,
      meta:{
        title:"好友分享"
      }
    },
    {
      path: '/voiceinvite',
      name: 'VoiceInvite',
      component:VoiceInvite,
      meta:{
        title:"语聊邀请"
      }
    },
    {
      path: '/invitegameroom',
      name: 'invitegameroom',
      component: Invitegameroom,
      meta:{
        title:"游戏房间邀请"
      }
    },
    {
      path: '/scriptinfos',
      name: 'scriptinfos',
      component: Scriptinfos,
      meta:{
        title:"剧本分享详情"
      }
    },
    {
      path: '/squareshare',
      name: 'squareshare',
      component: Squareshare,
      meta:{
        title:"广场分享详情"
      }
    },
    {
      path: '/giftbag',
      name: 'giftbag',
      component: ()=>import("@/Components/GiftBag.vue"),
      meta:{
        title:"礼包"
      }
    },
    {
      path: '/spygame_rules',
      name: 'Deceitserves',
      component:Deceitserves,
      meta:{
        title:"谁是卧底游戏规则"
      }
    },
    //谁是卧底 邀请（分享）
    {
      path: '/spygame_invite',
      name: 'Deceitshare',
      component:Deceitshare,
      meta:{
        title:"游戏分享"
      }
    },
     //h5 活动
     {
      path:"/gift_home",
      name :'giftHome',
      component:()=> import ("../components/h5gifts/view/giftHome.vue")
    },
    {
      path: '/active_info',
      name: 'activeInfo',
      component: ()=>import("../components/h5gifts/view/activeInfo.vue"),
    },
    {
      path: '/receive_list',
      name: 'reContribution',
      component: ()=>import("../components/h5gifts/view/reContribution.vue"),
    },
    {
      path: '/send_list',
      name: 'seContribution',
      component: ()=>import("../components/h5gifts/view/seContribution.vue"),
    },
    {
      path: '/emptypages',
      name: 'Emptypages',
      component: ()=>import("../components/h5gifts/view/Emptypages.vue"),
    },
    {
      path: '/fiction',
      name: 'fiction',
      component: ()=>import("../components/fiction"),
    },
    //狼人杀
    {
      path:'/lrsgame_rules',
      name :'Lrsrules',
      component:Lrsrules,
      meta:{
        title :'狼人杀游戏规则'
      }
    },
    {
      path:'/lrsgame_invite',
      name :'LrsShare ',
      component:LrsShare ,
      meta:{
        title :'狼人杀游戏邀请'
      }
    },
    //充值
    {
      path:'/pay_product',
      name :'Payproduct',
      component:()=>import ('../components/H5pay/view/product.vue'),
      meta:{
        title :'商城充值'
      }
    },
    //抽奖
    {
      path:'/lottery',
      name:"lottery",
      component: Lottery,
      meta:{
        title:'我是谜抽奖'
      }
    },
    //你画我猜
    {
      path:'/draw_rules',
      name :'Drawrules',
      component:Drawrules,
      meta:{
        title :'你画我猜游戏规则'
      }
    },
    {
      path:'/drawgame_invite',
      name :'DrawShare ',
      component:DrawShare ,
      meta:{
        title :'你画我猜游戏邀请'
      }
    },
    //微信支付教程
    {
      path:'/weixin_course',
      name :'Weixincourse ',
      component:Weixincourse ,
      meta:{
        title :'微信支付教程'
      }
    },

    {
      path: '/weixin_course_two',
      name: 'Weixincoursetwo',
      component: ()=>import("../components/wsm_month_card/pay/two.vue"),
    },
    {
      path: '/weixin_course_three',
      name: 'Weixincoursethree',
      component: ()=>import("../components/wsm_month_card/pay/three.vue"),
    },
    //月卡领取教程
    {
      path:'/yueka_course',
      name :'Yuekacourse ',
      component:Yuekacourse ,
      meta:{
        title :'月卡领取教程'
      }
    },
    {
      path: '/yueka_course_two',
      name: 'Yuekacoursetwo',
      component: ()=>import("../components/wsm_month_card/get/two.vue"),
    },
    {
      path: '/yueka_course_three',
      name: 'Yuekacoursethree',
      component: ()=>import("../components/wsm_month_card/get/three.vue"),
    },
    {
      path: '/yueka_course_four',
      name: 'Yuekacoursetwo',
      component: ()=>import("../components/wsm_month_card/get/four.vue"),
    },
    {
      path: '/yueka_course_five',
      name: 'Yuekacoursethree',
      component: ()=>import("../components/wsm_month_card/get/five.vue"),
    },
    {
      path: '/month_text',
      name: 'monthtext',
      component:Yuekainfos ,
      meta:{
        title:"月卡说明"
      }
    },



  ]

})





// WEBPACK FOOTER //
// ./src/router/index.js